import Component from "./Component.js"
import ListItem from "./ListItem.js"

export default class Panel extends Component {

  constructor(props, context) {
    super(props, context)
    this.closeHandler = this.closeHandler.bind(this)
    this._open = false
  }

  static get contextTypes() {
    return super.contextTypes
  }

  set open(value) {
    if (value == this._open)
      return

    this._open = value
    this.classList.update({"amp-open": this._open})
    this.plugin.open = value

    if (this._open) {
      document.addEventListener("click", this.closeHandler)
      this.context.plugin.activeState = "active"
      this.context.plugin.stopIdleTimeout()
      if (this.props.onopen)
        this.props.onopen(this)
    } else {
      this.context.plugin.startIdleTimeout()
      document.removeEventListener("click", this.closeHandler)
      if (this.props.onclose)
        this.props.onclose(this)
    }

  }

  get open() {
    return this._open
  }

  get propsList() {
    const { onclose, onopen, ...props } = super.propsList
    return props
  }

  get title() {
    return "TITLE"
  }

  closeHandler(event) {
    if (this.element === undefined || this.element.contains(event.target))
      return

    this.open = false
    document.removeEventListener("click", this.closeHandler)
  }

  toggle() {
    this.open = !this.open
  }

  close() {
    this.open = false
  }

  isOptionSelected(item, index) {
    return (index === this.state.activeIndex)
  }

  clickHandler(object, index) {
    this.setState({activeIndex: index})
  }

  backHandler(event) {
    this.props.gotoSettings(event)
  }

  render() {
    const items = this.listOptions.map((object, index) => {
      return <ListItem key={index} onClick={this.clickHandler.bind(this, object, index)}>
              <button tabIndex="-1" className={this.isOptionSelected(object, index) ? 'amp-icon amp-list-item-selected':'amp-icon'}></button>
              <span>{object.label}</span>
             </ListItem>
    })

    return <div ref="element">
            <ListItem className="amp-list-title" onClick={this.backHandler.bind(this)} direction="left">
              <button tabIndex="-1" className="amp-icon amp-icon-left"></button>
              <span>{this.state.title}</span>
            </ListItem>
            {items}
           </div>
  }
}
